import styled from "styled-components";
import { useEffect, useState } from "react";
import { fetchCompanyPublicLabel } from "../services/interviewService";
import { requestFullscreen } from '../utils/fullscreen';

export default function Home({ setShowFormContainer, company, initialCompany = '' }) {
    const [companyLabel, setCompanyLabel] = useState('');

    function changePage () {
        requestFullscreen();
        setShowFormContainer(true);
    }

    const normalizedCompany = (company || initialCompany || '').toLowerCase();

    useEffect(() => {
        let cancelled = false;
        const fetchCompanyLabel = async () => {
            if (!normalizedCompany) return;
            try {
                const label = await fetchCompanyPublicLabel({ company: normalizedCompany });
                if (!cancelled && label) {
                    setCompanyLabel(label);
                    return;
                }
            } catch (err) {
                console.error('Erro ao buscar companyLabel:', err);
            }
            if (!cancelled) {
                setCompanyLabel(normalizedCompany === 'materdei'
                    ? 'da Rede Mater Dei'
                    : `do Grupo ${(company || initialCompany || '').toUpperCase()}`);
            }
        };
        fetchCompanyLabel();
        return () => {
            cancelled = true;
        };
    }, [normalizedCompany, company, initialCompany]);

    return (
        <>
            <MainContainer>
                <TextContainer>
                    <h1>Seja bem vindo(a) a <span style={{fontWeight: 500}}>EIA</span>, a primeira ferramenta do Brasil de entrevista de Compliance com inteligência artificial.</h1>
                    <p> É com grande satisfação que o(a) convidamos para uma conversa que objetiva melhorar, ainda mais, o clima organizacional { companyLabel }. Por favor, clique em iniciar e preencha os seus dados. </p>
                    <Button onClick={() => changePage()}>
                        <p>Iniciar</p>
                    </Button>
                </TextContainer>
            </MainContainer>
        </>
    )
}

const MainContainer = styled.div`
    display: flex;
    background-color: #FAF4FC;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100vw !important;

    @media (max-width: 1250px) {
        flex-direction: column;
        align-items: center;
        justify-content: start;
    }

    @media (max-width: 480px) {
        width: 100%;
    }
`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h1 {
        font-family: "Poppins", sans-serif;
        font-size: 52px;
        letter-spacing: 1px;
        line-height: 1.2;
        color: #333;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
        text-transform: center;
        padding: 20px;
    }
    p {
        font-family: "Poppins", sans-serif;
        font-size: 22px;
        letter-spacing: 1px;
        line-height: 1.2;
        color: #333;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
        margin-top: 10px;
        padding: 20px;
    }
    
    @media (max-width: 1498px) {
        margin-top: 30px;
        h1 {
            font-size: 42px;
        }
        p {
            font-size: 18px;
        }
    }

    @media (max-width: 480px) {
        width: 100vw;
    }
`

const Button = styled.button`
    margin-top: 10px;
    width: 340px;
    height: 64px;
    background-color: #000;
    box-shadow: 4px 4px 6px #BACCDE89;
    border: none;
    border-radius: 16px;
    cursor: pointer;
    p {
        margin-top: 0;
        color: #fff;
        font-family: "Poppins", sans-serif;
    }
`
